<template>
  <div id="common-user-list">
    <a-list
    :dataSource="userListData"
    >
      <a-list-item slot="renderItem" slot-scope="item">
         <router-link
          :to="{ name: 'user-profile', params: { userId: item.id } }"
        >
          <a-list-item-meta :description="item.user_extra.user_email">
            <h3 slot="title">{{item.user_extra.first_name}} {{item.user_extra.last_name}}</h3>
          </a-list-item-meta>
         </router-link>
      </a-list-item>
      <!-- <div v-if="loading && !busy" class="demo-loading-container">
        <a-spin />
      </div> -->
    </a-list>
  </div>
</template>
<script>
export default {
  name: 'common-user-list',
  props: {
    userListData: {
      type: Array,
      required: true,
    },
  },
};
</script>
